import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inductionprogram',
  templateUrl: './inductionprogram.component.html',
  styleUrls: ['./inductionprogram.component.scss']
})
export class InductionprogramComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
